export default (set, get, data) => set(
  () => ({
    design: {
      ...get().design,
      ...data?.design
    },
    bundles: {
      ...get().bundles,
      added: [...data?.bundles]
    }
  }),
  false,
  { type: 'LOAD', data }
);
